import styled, { css } from 'styled-components';

import { Flex } from '@/components/Flex';
import type { ContentfulCardFragment } from '@/graphql/contentful/api';
import { getBrandConfig } from '@/lib/configuration/configuration';

import { getTextAlignment } from '../../Card.styles';

export const Content = styled(Flex)<
  Pick<ContentfulCardFragment, 'textAlignment'> & {
    deskTopContentMaxWidth: string;
  }
>`
  flex-direction: column;
  max-width: 400px;
  word-break: break-word;
  white-space: pre-wrap;
  z-index: 1;

  ${({ deskTopContentMaxWidth, textAlignment, theme }) => css`
    font-size: ${theme.fontSizes.p2};
    ${theme.media.md.down} {
      max-width: 100%;
      width: 100%;
      margin: 0 0;
      ${getTextAlignment(getBrandConfig().textAlignmentMobile)}
    }
    @media (min-width: 991px) and (max-width: 992px) {
      max-width: 100%;
      width: 100%;
      margin: 0 0;
      ${getTextAlignment(getBrandConfig().textAlignmentMobile)}
    }
    ${theme.media.md.up} {
      max-width: ${deskTopContentMaxWidth ? deskTopContentMaxWidth : '500px'};
      ${getTextAlignment(textAlignment)}
      justify-content: space-between;
    }

    ${theme.media.lg.up} {
      max-width: ${deskTopContentMaxWidth ? deskTopContentMaxWidth : '550px'};
      ${getTextAlignment(textAlignment)}
      justify-content: space-between;
    }
  `}
`;
